// Ozera sticky mobile add-to-cart. It follows the visible mobile purchase button, then proxies
// a click to that form so Dawn's product-form.js still owns the cart request.
(function () {
  var sticky = document.querySelector('[data-oz-sticky]');
  var heroAtc = document.querySelector('[data-oz-hero-atc]');
  if (!sticky || !heroAtc) return;

  var stickyBtn = sticky.querySelector('[data-oz-sticky-add]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      heroAtc.click();
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      sticky.dataset.show = !entry.isIntersecting ? 'true' : 'false';
      stickyBtn.disabled = heroAtc.disabled || heroAtc.getAttribute('aria-disabled') === 'true';
    },
    { threshold: 0 }
  );
  observer.observe(heroAtc);
  new MutationObserver(function () {
    stickyBtn.disabled = heroAtc.disabled || heroAtc.getAttribute('aria-disabled') === 'true';
  }).observe(heroAtc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
})();
